import * as Yup from 'yup';

const registerFormConfig = Yup.object().shape({
    userName: Yup.string().required('Name is required'),
    password: Yup.string().required('password required'),
});

export default registerFormConfig;